import { shopSettingsApi } from './api';

export const WARNING_LEAD_MS = 2 * 60 * 1000;
const DEFAULT_MIN = 120;
const MIN_MIN = 5;
const MAX_MIN = 1440;

const clamp = (n: number) => Math.min(MAX_MIN, Math.max(MIN_MIN, n));

export async function getIdleTimeoutMs(): Promise<number> {
  try {
    const { data } = await shopSettingsApi.get();
    const raw = (data as any)?.session_idle_timeout_minutes;
    const minutes = typeof raw === 'number' && !Number.isNaN(raw) ? clamp(raw) : DEFAULT_MIN;
    return minutes * 60 * 1000;
  } catch {
    return DEFAULT_MIN * 60 * 1000;
  }
}
